// const entityExtractRoutes = [
//   // {
//   //   path: '/entity-extract/entity',
//   //   name: '实体',
//   //   component: () => import('@/views/entity-extract/entity')
//   // },
//   {
//     path: '/entity-extract/rule',
//     name: '规则实体',
//     component: () => import('@/views/entity-extract/rule')
//   },
//   {
//     path: '/entity-extract/gather',
//     name: '集合实体',
//     component: () => import('@/views/entity-extract/gather')
//   }
// ]
export const entityExtractRoutes = [
  {
    path: '/entity/system',
    name: '系统实体页面',
    component: () => import('@/views/entity/system')
  },
  {
    path: '/entity/custom',
    name: '自定义实体管理',
    component: () => import('@/views/entity/custom'),
    children: [
      {
        name: '实体标注',
        path: '/entity/custom/tag',
        component: () => import('@/views/entity/custom/tag')
      }, {
        name: '规则类实体',
        path: '/entity/custom/rule',
        component: () => import('@/views/entity/custom/rule')
      }
    ]
  },
  {
    path: '/entity/gather',
    name: '集合实体',
    component: () => import('@/views/entity-extract/gather')
  }
]
export default entityExtractRoutes
